import { User } from '../../types/user';
import http from '../http';

/**
 * Fetches the current user information from the API
 */
export const getCurrentOpalUser = async (instanceId?: string | null): Promise<User> => {
  const response = await http.get<User>('/api/v1/user/current-user', {
    headers: {
      'X-Instance-Id': instanceId,
    },
    timeout: 60000, // 1 minute
  });
  return response.data;
};
